module.exports = __webpack_public_path__ + "static/media/physics_banner.3543d53f.jpg";